import { useEffect, useRef } from "react";

const DWELL_MS = 3000;

export function usePageViewTracker({
  documentId,
  pageId,
  documentUserId,
  enabled = true,
}: {
  documentId: string;
  pageId: string | null;
  documentUserId: string | null;
  enabled?: boolean;
}) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!pageId || !documentUserId || !enabled) return;

    timerRef.current = setTimeout(async () => {
      try {
        await fetch(`/api/documents/${documentId}/pages/${pageId}/viewed`, {
          method: "POST",
          headers: { "x-document-user-id": documentUserId },
        });
      } catch {
        // fire-and-forget — never block the viewer on failures
      }
    }, DWELL_MS);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [documentId, pageId, documentUserId, enabled]);
}
